import React from 'react';
import SEO from '../components/SEO';
import SavingsModalitiesSection from '../components/SavingsModalitiesSection';

const Precios = () => {
  return (
    <>
      <SEO pathname="/precios" />
      <div className="pt-20">
        <SavingsModalitiesSection />
      </div>
    </>
  );
};

export default Precios;
